<template>
  <v-app>
    <AllowedUserAuthContainer :page-types="['writer']">
      <SessionShareContainer />
      <master-writer-header />
      <v-main>
        <div
          class="d-flex justify-space-between"
          style="position: relative; margin-top: 70px"
        >
          <template v-if="currentUserAuth.id">
            <router-view name="subSidebar" />
            <router-view />
          </template>

          <template v-else>
            <v-overlay>
              <v-progress-circular indeterminate size="64" z-index="2000" />
            </v-overlay>
          </template>
        </div>

        <slot />
      </v-main>
    </AllowedUserAuthContainer>
    <toaster />
    <loading-overlay />
    <SystemInformationConfirmDialog></SystemInformationConfirmDialog>
  </v-app>
</template>

<script>
import MasterWriterHeader from '@/components/masterWriterLayout/Header'
import Toaster from '@/components/commons/Toaster'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import { mapState } from 'vuex'
import AllowedUserAuthContainer from '../../src/container/shared/AllowedUserAuthContainer'
import SessionShareContainer from '../../src/container/shared/SessionShare'
import SystemInformationConfirmDialog from '../../src/container/shared/SystemInformationDetailDialogs/confirm.vue'

export default {
  name: 'App',
  components: {
    SessionShareContainer,
    AllowedUserAuthContainer,
    MasterWriterHeader,
    Toaster,
    LoadingOverlay,
    SystemInformationConfirmDialog
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => {
        return state.UserAuthStore.currentUserAuth
      }
    })
  }
}
</script>
